/*
 * How a Brief PDF export is paced, stated once for the API that renders it and the page that waits
 * for it.
 */

/** How many renders an API process runs at once, and how many it queues behind them. */
export const BRIEF_EXPORT_CONCURRENCY = { active: 1, waiting: 3 } as const;

/** How long one render may take, launch to bytes, before its browser is closed under it. */
export const BRIEF_EXPORT_RENDER_TIMEOUT_MS = 90_000;

/** How long a refusal for being busy tells the caller to wait before asking again, in seconds. */
export const BRIEF_EXPORT_RETRY_AFTER_SECONDS = 5;
